import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleRedirectService } from '@core/services/role-redirect.service';

@Component({
  selector: 'app-ui-organism-redirect-by-role',
  template: '',
  standalone: true,
})
export class RedirectByRoleComponent implements OnInit {
  constructor(
    private readonly roleRedirectService: RoleRedirectService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    // Redirigir al home según el rol del usuario
    this.roleRedirectService.redirectToHome();
  }
}
